// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import {FormattedMessage} from 'react-intl';
import {downloadFile} from '../../../shared/services/file-download';

function onFileClick(file) {

    downloadFile(file);

}

const Attachments = props =>
    <div className='attachments'>
        <h4>
            <FormattedMessage id='ATTACHMENTS'/>
        </h4>
        <ul>
            {props.files.map((file, index) =>
                <li key={index}>
                    <button
                        className='button-text'
                        onClick={onFileClick.bind(null, file)}
                    >
                        {file.fileName}
                    </button>
                </li>
            )}
        </ul>
    </div>;

Attachments.displayName = 'Attachments';
Attachments.propTypes = {
    files: PropTypes.arrayOf(PropTypes.instanceOf(File)).isRequired
};

export default Attachments;



// WEBPACK FOOTER //
// ./src/tcsm/shared/components/attachments.js